module.exports = __webpack_public_path__ + "d721bd666a79aef72fd592824b5f0a74.ogg";